import { authService } from '@/api'
import user from '@/store/modules/auth/user'

const initialState = () => ({
  token: null
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async authenticate({ commit }) {
      const { settings, ...user } = await authService.get('CURRENT_USER')
      commit('auth/user/assign', user, { root: true })
      commit('auth/user/settings/assign', settings, { root: true })
      return user
    },
    async login({ commit }, email) {
      try {
        const result = await authService.create({ email, is_site_app: true })
      } catch (e) {
        console.error(e)
      }
    },
    async token({ commit, dispatch }, token) {
      if (!token) return null
      commit('assignToken', token)
      localStorage.setItem('picnic-team-jwt', token)
      return token
    },
    async logout({ commit }) {
      await authService.remove('CURRENT_USER')
      commit('assignToken', null)
      commit('auth/user/reset', null, { root: true })
      commit('auth/user/settings/reset', null, { root: true })
      localStorage.removeItem('picnic-team-jwt')
    }
  },

  mutations: {
    assignToken(state, data) {
      state.token = data
    },
    reset(state) {
      state.all = []
    }
  },
  modules: {
    user
  }
}
